import { Box, Typography } from "@mui/material";
import { ProgressBar } from "react-bootstrap";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useState } from "react";

export default function ContractProgressBar() {

    const [selectedBell, setSelectedBell] = useState(false)

    // FIXME - FALTA COMPORTAMENTO
    const handleSelectedBell = (event: any): void => {
        setSelectedBell(!selectedBell);
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '114px', width: '100%', padding: '16px' }}>
                <Typography style={{ width: '25%', fontWeight: '500', fontSize: '21px' }}>DOCUMENTOS CONTRATAÇÃO</Typography>
                <div style={{ width: '75%', height: '100%'}}>
                    <div style={{ display: 'flex', height: '100%', width: '100%', flexDirection: 'column', padding: '8px' }}>
                        <Typography style={{ paddingBottom: '5px' }} fontWeight={'bold'}>Indicador do Progresso dos Processos</Typography>
                        <ProgressBar style={{ height: '16px', background: 'var(--progress-bar-grey)' }}>
                            <ProgressBar  style={{ backgroundColor: 'var(--progress-bar-primary)' }} now={35} key={1}></ProgressBar>
                            <ProgressBar  style={{ backgroundColor: 'var(--progress-bar-secondary)' }} now={20} key={2}></ProgressBar>
                        </ProgressBar>
                        <div style={{ display: 'flex', paddingTop: '5px' }}>
                            <div style={{ display: 'flex' }}>
                                <Typography>Pendente</Typography>
                                <Box borderRadius={30} sx={{ backgroundColor: 'var(--progress-bar-grey)', width: '25px', height: '12px', marginLeft: '5px', alignSelf: 'center'  }}></Box>
                            </div>
                            <div style={{ display: 'flex', marginLeft: '5px' }}>
                                <Typography>Completo</Typography>
                                <Box borderRadius={30} sx={{ backgroundColor: 'var(--progress-bar-secondary)', width: '25px', height: '12px', marginLeft: '5px', alignSelf: 'center'  }}></Box>
                            </div>
                            <div style={{ display: 'flex', marginLeft: '5px' }}>
                                <Typography>Aprovado</Typography>
                                <Box borderRadius={30} sx={{ backgroundColor: 'var(--progress-bar-primary)', width: '25px', height: '12px', marginLeft: '5px', alignSelf: 'center'  }}></Box>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={handleSelectedBell}>
                        <NotificationsNoneIcon style={{ position: 'relative', top: '-15px', right: '-5px', color: 'var(--notification-bell)' }}/>
                    </div>
                </div>
            </div>
    )
}